import React from 'react';
import { Layout, Users, Trophy, SwatchBook, CheckSquare, Settings, LogOut, Info, Globe, X, ShoppingBag, Mail, HelpCircle, Shield } from 'lucide-react';
import { supabase } from '../services/supabaseClient';
import logoSavat from '../assets/logo_savatevent.jpg';
import packageJson from '../../package.json';

const MenuItem = ({ id, icon: Icon, label, activeTab, setActiveTab, onCloseMobile }) => {
  return (
    <div 
      onClick={() => {
        setActiveTab(id);
        if (onCloseMobile) onCloseMobile();
      }} 
      className="sidebar-menu-item"
      style={{ 
        padding: "14px 20px", cursor: "pointer", 
        backgroundColor: activeTab === id ? "#3182ce" : "transparent", 
        display: "flex", alignItems: "center", gap: "12px", fontSize: "14px", transition: "0.2s",
        color: "white"
      }}
    >
      <Icon size={18} /> {label}
    </div>
  );
};

export default function Sidebar({ 
  session, 
  selectedCompetition, 
  activeTab, 
  setActiveTab, 
  onBackToDashboard, 
  isOpen, 
  onClose,
  isMobile,
  isAdmin 
}) {
  const sidebarStyle = {
    width: "260px",
    backgroundColor: "#2c5282",
    color: "white",
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
    transition: "transform 0.3s ease",
    zIndex: 1000,
    position: isMobile ? "fixed" : "relative",
    top: isMobile ? 0 : undefined,
    left: isMobile ? 0 : undefined,
    transform: isMobile && !isOpen ? "translateX(-100%)" : "translateX(0)",
    flexShrink: 0,
  };

  return (
    <div style={sidebarStyle}>
      {isMobile && (
        <button onClick={onClose} style={{ position: 'absolute', right: '15px', top: '15px', background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}>
          <X size={24} />
        </button>
      )}

      <div style={{ padding: "20px", borderBottom: "1px solid rgba(255,255,255,0.1)", display: 'flex', alignItems: 'center', gap: '12px' }}>
        <img 
          src={logoSavat} 
          alt="Logo" 
          style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.2)' }} 
        />
        <h2 style={{ fontSize: "1.1rem", fontWeight: "bold", margin: 0, letterSpacing: '0.5px' }}>SavatEvent</h2>
      </div>

      <nav style={{ 
        flex: 1, 
        paddingTop: "10px", 
        overflowY: "auto",
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} className="sidebar-nav">
        <div style={{ fontSize: "11px", color: "#a0aec0", padding: "10px 20px", textTransform: "uppercase", letterSpacing: "1px" }}>Général</div>
        
        <MenuItem 
          id="home" icon={Trophy} label="Accueil" activeTab={activeTab} 
          setActiveTab={(id) => { setActiveTab(id); onBackToDashboard(); }} 
          onCloseMobile={onClose}
        />
        <MenuItem 
          id="public_list" icon={Globe} label="Compétitions publiques" activeTab={activeTab} 
          setActiveTab={(id) => { setActiveTab(id); onBackToDashboard(); }} 
          onCloseMobile={onClose}
        />
        <MenuItem 
          id="list_competitions" icon={Layout} label="Mes compétitions" activeTab={activeTab} 
          setActiveTab={(id) => { setActiveTab(id); onBackToDashboard(); }} 
          onCloseMobile={onClose}
        />
        <MenuItem 
          id="faq" icon={HelpCircle} label="Aide & FAQ" activeTab={activeTab} 
          setActiveTab={(id) => { setActiveTab(id); onBackToDashboard(); }} 
          onCloseMobile={onClose}
        />

        {isAdmin && (
          <MenuItem 
            id="admin_panel" icon={Shield} label="Administration" activeTab={activeTab} 
            setActiveTab={(id) => { setActiveTab(id); onBackToDashboard(); }} 
            onCloseMobile={onClose}
          />
        )}

        {selectedCompetition && (
          <React.Fragment>
            <div style={{ marginTop: "20px", fontSize: "11px", color: "#a0aec0", padding: "10px 20px", textTransform: "uppercase", letterSpacing: "1px", borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: "20px" }}>
              {selectedCompetition.name}
            </div>
            <MenuItem id="info_generale" icon={Info} label="Infos" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
            <MenuItem id="dashboard" icon={Layout} label="Live" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
            <MenuItem id="categories" icon={SwatchBook} label="Catégories & Athlètes" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
            <MenuItem id="matchs" icon={CheckSquare} label="Matchs" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
            <MenuItem id="parametres_comp" icon={Settings} label="Config Compétition" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
          </React.Fragment>
        )}

        {/* Mon Compte — dans le nav pour rester scrollable sur mobile */}
        <div style={{ marginTop: "20px", borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "10px", paddingBottom: "calc(10px + env(safe-area-inset-bottom))" }}>
          {isMobile ? (
            <React.Fragment>
              <div style={{ padding: "10px 20px", fontSize: "11px", color: "#a0aec0", textTransform: "uppercase" }}>Mon Compte</div>
              <MenuItem id="parametres" icon={Settings} label="Réglages" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
              <MenuItem id="commandes" icon={ShoppingBag} label="Mes Commandes" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
              <MenuItem id="contact" icon={Mail} label="Nous contacter" activeTab={activeTab} setActiveTab={setActiveTab} onCloseMobile={onClose} />
              <div
                onClick={() => supabase.auth.signOut()}
                style={{ padding: "14px 20px", cursor: "pointer", color: "#fc8181", display: "flex", alignItems: "center", gap: "12px", fontSize: "14px" }}
              >
                <LogOut size={18} /> Se déconnecter
              </div>
            </React.Fragment>
          ) : (
            <div style={{ padding: "15px 20px", fontSize: "12px", color: "#a0aec0", textAlign: 'center' }}>
              SavatEvent v{packageJson.version}
            </div>
          )}
        </div>
      </nav>
    </div>
  );
}
